import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { lastValueFrom } from 'rxjs';
import { FinzyService } from 'src/app/core/services/finzy.service';
import swal from 'sweetalert2';

@Component({
  selector: 'app-current-address',
  templateUrl: './current-address.component.html',
  styleUrl: './current-address.component.scss'
})
export class CurrentAddressComponent {
  model!: FormGroup;
  selectedResidence: string = '';
  fileSelected: boolean = false;
  base64File: string = '';
  fileExtension: string = '';

  residenceTypes = ['I Own My Home', 'I Live in a Rented Home'];
  documentOwnedTypes = ['Masked e-Aadhaar', 'Driving License', 'Passport', 'Voter ID', 'Electricity bill (< 3 months old)', 'LPG bill (< 3 months old)', 'BSNL/MTNL landline bill (< 3 months old)'];
  documentRentedTypes = ['Masked e-Aadhaar', 'Driving License', 'Passport', 'Voter ID', 'Electricity bill (< 3 months old)', 'LPG bill (< 3 months old)', 'BSNL/MTNL landline bill (< 3 months old)'];

  constructor(private fb: FormBuilder, private finzyService: FinzyService, private router: Router, private spinner: NgxSpinnerService) { }

  ngOnInit(): void {
    this.spinner.hide();
    this.model = this.fb.group({
      residenceType: ['', Validators.required],
      documentType: ['', Validators.required],
    });
  }

  onResidenceSelect(type: string): void {
    this.selectedResidence = type;
    this.model.get('residenceType')?.setValue(type);
    this.model.get('documentType')?.reset();
    this.model.get('documentType')?.patchValue('Select document type');
  }

  onFileSelected(event: any): void {
    const file = event.target.files[0];
    if (!file) return;

    const allowedTypes = ['application/pdf', 'image/jpeg', 'image/png'];
    if (!allowedTypes.includes(file.type)) {
      alert('Only PDF, JPG, JPEG, or PNG files are allowed.');
      this.fileSelected = false;
      return;
    }

    this.fileExtension = file.name.split('.').pop()!;
    const reader = new FileReader();

    reader.onload = () => {
      const base64String = (reader.result as string).split(',')[1];
      this.base64File = base64String;
      this.fileSelected = true;
    };

    reader.readAsDataURL(file);
  }

  get m() {
    return this.model.controls;
  }

  async submit() {
    if (!this.model.valid || !this.fileSelected) {
      swal.fire('error', 'Please complete the form and upload a valid file.');
      return;
    }

    this.spinner.show();
    const payload = {
      residenceType: this.model.value.residenceType,
      documentType: this.model.value.documentType,
      docType: "CurrentAddress",
      extension: this.fileExtension,
      currentAddressProofBase64: this.base64File,
    };

    try {
      var res = await lastValueFrom(this.finzyService.UploadDocuments(payload));
      if (res['data'] === 'success') {
        this.router.navigateByUrl('/assist-journey/f/income-details');
      }
    } catch (err) {
      if (err?.status === 401) {
        this.spinner.hide();
        return this.router.navigateByUrl('/assist-journey/session-expired');
      }

      if (err.status === 0) {
        this.spinner.hide();
        swal.fire('Error', 'Network Error: Please check your internet connection and try again.');
        return;
      }
    }

    //handler error 
    console.log(res);

  }
}
